export default [
  {
    title: 'صفحه اصلی',
    icon: 'HomeIcon',
    route: 'dashboard-ecommerce',
    // children: [
    //   {
    //     title: 'صفحه اصلی',
    //     route: 'dashboard-ecommerce',
    //     resource: 'test',
    //     action: 'test',
    //   },
    //   {
    //     title: 'Analytics',
    //     route: 'dashboard-analytics',
    //     resource: 'test',
    //     action: 'test',
    //   },
    // ],
  },
  {
    title: 'آمار سایت',
    icon: 'ActivityIcon',
    route: 'dashboard-ecommerce-analytics',
  },
  // {
  //   title: 'گزارش هوشمند',
  //   icon: 'BarChart2Icon',
  //   route: 'dashboard-ecommerce-smartReport',
  // },
]
